module.exports = __webpack_public_path__ + "static/rainslasher-334f88910704ae8b48b0c864abd55692.png";